import React from 'react'
import TalentAppStep from "../components/TalentAppStep";
import SchoolForm from "../components/SchoolForm";

export default class EducationStep extends TalentAppStep {
    static path = '/education';
    static LastUpdatedMethod = 'lastUpdatedEducation';

    static HasRequirements = true;
    /**
     * The title shown on the form
     */
    static StepTitle = 'Education';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = TB.trans('talent.education.step_subtitle');
    /**
     * The start page info tile
     */
    static StepInfo = TB.trans('talent.education.step_info');
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Resume';
    /**
     * Hide completion icon on sidebar
     */
    static NeedsCompletion = () => false;

    /**
     * Show brief details for user
     */
    static ProfileSectionSummary = (user) => {
        if(!this.hasCompleted(user)) return false;
        return `${user.schools?.length} Education`;
    };

    static hasCompleted(user) {
        // let items = TB.pick(user, ['schools']);
        //
        // items = TB.flatten(TB.values(items));
        //
        // items = TB.filter(items, item => TB.isDefined(item?.name))
        //
        // return items.length > 0;
        return true;
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        return user.validateEducation()
    };

    /**
     * Render the form
     *
     * @returns {Form}
     */
    renderFormFooter() {

        return (
            <div className="pb-6">
                <div>
                    {this.renderChildForm({
                        displayName: TB.trans('talent.education.school_form_display_name'),
                        ChildFormComponent: SchoolForm,
                        userProp: 'schools'
                    })}

                </div>

            </div>
        );
    }

    /**
     * Are requirements optional?
     *
     * @returns boolean
     */
    isRequirementOptional() {
        return true;
    }

    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return 'Education is optional and not required.';
    }
}